import t from "react";
import { Authenticator as e } from "./Authenticator.js";
function r(r) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _n$variation = n.variation,
    o = _n$variation === void 0 ? "modal" : _n$variation;
  return function (a) {
    return t.createElement(e, Object.assign({
      variation: o
    }, n), function (e) {
      return t.createElement(r, Object.assign({}, a, e));
    });
  };
}
export { r as withAuthenticator };